import React from 'react';
import { injectIntl, FormattedNumber } from 'react-intl';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Clearfix, Label } from 'react-bootstrap';
import { findIndex as _findIndex } from 'lodash';

import { getNameInCurrentLanguage } from 'helpers/intl';
import { getAuthorizationLabel, getAuthorizationType } from 'helpers/order';

import IntlDate from 'components/layout/IntlDate';
import IntlDateTime from 'components/layout/IntlDateTime';
import FabActions from 'components/layout/FabActions';
import FabActionElement from 'components/layout/FabActionElement';

import IntlFormInlineSelector from 'components/intlForm/IntlFormInlineSelector';

import OrderActions from 'components/layout/order/OrderActions';
import OrderAuthDetails from 'components/modals/OrderAuthDetails';
import may from "../../../security";
import {ROLE_ROOT_EMPLOYEE} from "../../../constants";

class OrderInfos extends React.Component {
  constructor(props) {
    super(props);

    const { inModal } = props;

    this.state = {
      compact: inModal,
      showAuthDetails: false,
    };
  }

  showDetails = e => {
    e.preventDefault();

    this.setState({ compact: false });
  };

  showAuthDetails = e => {
    e.preventDefault();

    this.setState({ showAuthDetails: true });
  };

  closeAuthDetails = () => {
    this.setState({ showAuthDetails: false });
  };

  getProgress = () => {
    const {
      intl: { messages },
      appIntl,
      entity,
      user
    } = this.props;

    let currentProgress = 0;
    let countStages = 0;
    if (entity.getLeadPipeline() && entity.getLeadCurrentStage()) {
      currentProgress = _findIndex(entity.getLeadPipeline().getStages(), ['id', entity.getLeadCurrentStage()]);
      countStages = entity.getLeadPipeline().getStages().length;
    }

    const progressElements = [];
    for (let j = 0; j < countStages; j++) {
      progressElements.push(
        <div className="pull-left" style={{ width: (1 / countStages) * 100 + '%' }} key={j}>
          <div className={'m-r-5 bg-' + (j <= currentProgress ? 'primary-light' : 'white')} style={{ height: '3px' }} />
        </div>
      );
    }

    return (
      <dd className="m-t-5 sm-m-t-0 p-t-10 p-b-5" key="order-progress">
        <div className="clearfix m-b-10">{progressElements}</div>

        {!!entity.getLeadPipeline().getId() && (
          <>
            <IntlFormInlineSelector />{' '}
            {getNameInCurrentLanguage(
              entity
                .getLeadPipeline()
                .getStages()
                [currentProgress].getName(),
              appIntl
            )}
          </>
        )}

        {!!entity.getLeadId() && may(ROLE_ROOT_EMPLOYEE, user.roles) && (
          <Link
            className="text-master hint-text pull-right"
            to={appIntl.urlPrefix + 'account/leads/' + entity.getLeadId()}
          >
            <i className="fal fa-angle-double-right" /> {messages.view_lead_details}
          </Link>
        )}
      </dd>
    );
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      history,
      showActions,
      addEditAction,
      showProgress,
      entity,
      inModal,
      pipeline
    } = this.props;
    const { compact, showAuthDetails } = this.state;

    const addActions = [];
    if (addEditAction) {
      addActions.push(
        <FabActionElement
          size="60"
          icon="fas fa-pencil-alt"
          caption={messages.edit}
          action={() => history.push(appIntl.urlPrefix + 'account/orders/' + entity.getId())}
        />
      );
    }

    let appIntlDe = {displayIntlForm: 'de'};

    return (
      <Clearfix>
        {inModal && compact && (
          <a href="#showDetails" className="block clearfix text-master" onClick={this.showDetails}>
            <span className="pull-left block">
              <i className="fal fa-chevron-down" />
            </span>
            <span className="block m-l-25">
              (#{entity.getId()}) <IntlDate date={entity.getCdate()} />{' '}
              <FormattedNumber value={entity.getSumGross()} style="currency" currency={entity.getCurrency()} />
            </span>
          </a>
        )}

        {(!inModal || !compact) && (
          <>
            <dl className="no-margin full-width">
              <dt>{messages.order}</dt>
              <dd>{entity.getId()}</dd>

              {showProgress && (
                <>
                  <dt className="m-t-5">{messages.status}</dt>
                  {this.getProgress()}
                </>
              )}

              {!!entity.getAuthorizationList() && !!entity.getAuthorizationList().length && (
                <>
                  <dt className="m-t-5">{messages.authorization_status}</dt>
                  <dd className="p-t-10">
                    {entity.getAuthorizationList().map(authCheck => {
                      if (authCheck.type === getAuthorizationType(getNameInCurrentLanguage(pipeline?.getName?.(), appIntlDe))) {
                        return (
                          <div key={authCheck.type} className="m-b-15">
                            <span>
                              <span className="fa-stack">
                                <i className="fas fa-square fa-stack-2x text-white" />
                                {authCheck.getIsAuthorized() && (
                                  <i className="fa-fw fas fa-check-circle fa-stack-1x text-success" />
                                )}
                                {authCheck.getIsRejected() && (
                                  <i className="fa-fw fas fa-times-circle fa-stack-1x text-danger" />
                                )}
                                {authCheck.getAreChangesRequested() && (
                                  <i className="fa-fw fas fa-exclamation-triangle fa-stack-1x text-warning" />
                                )}
                                {!authCheck.getIsAuthorized() &&
                                  !authCheck.getIsRejected() &&
                                  !authCheck.getAreChangesRequested() && (
                                    <i className="fa-fw fas fa-hourglass-start fa-stack-1x text-info" />
                                  )}
                              </span>
                            </span>{' '}
                            <span className="p-r-15 inline">{getAuthorizationLabel(authCheck.type, messages)}</span>{' '}
                            <span className="inline">
                              {authCheck.getIsAuthorized() && <Label bsStyle="success">{messages.completed}</Label>}
                              {authCheck.getIsRejected() && <Label bsStyle="danger">{messages.rejected}</Label>}
                              {authCheck.getAreChangesRequested() && (
                                <Label bsStyle="warning">{messages.changes_requested}</Label>
                              )}
                              {!authCheck.getIsAuthorized() &&
                                !authCheck.getIsRejected() &&
                                !authCheck.getAreChangesRequested() && (
                                  <Label bsStyle="info">{messages.in_progress}</Label>
                                )}
                            </span>
                            <span className="inline p-l-15">
                              <a href="#showAuthDetails" onClick={this.showAuthDetails} className="text-master">
                                {!authCheck.getIsAuthorized() && !authCheck.getIsRejected() ? (
                                  <>
                                    <i className="fa fa-pencil-alt" /> {messages.edit}
                                  </>
                                ) : (
                                  <>
                                    <i className="fas fa-info-circle" /> {messages.infos}
                                  </>
                                )}
                              </a>
                            </span>
                          </div>
                        );
                      }
                    })
                    }
                  </dd>
                </>
              )}

              <dt className="m-t-5">{messages.date_created}</dt>
              <dd>
                <IntlDateTime date={entity.getCdate()} />
              </dd>

              <dt className="m-t-5">{messages.type}</dt>
              <dd>{messages.orderTypes[entity.getType()]}</dd>

              <dt className="m-t-5">{messages.salesDoc.total_due}</dt>
              <dd>
                <FormattedNumber value={entity.getSumGross()} style="currency" currency={entity.getCurrency()} />
              </dd>
            </dl>
          </>
        )}
        {/*
        {showActions && (
          <div className="top-right m-t-20" style={{ marginLeft: '-70px' }}>
            <FabActions>
              <OrderActions
                order={entity.processedData ? entity.processedData : entity}
                wrapperComponent={null}
                listItemComponent={<FabActionElement size="60" />}
                addActions={addActions}
              />
            </FabActions>
          </div>
        )}
        */}
        <div id="order-auth-details">
          <OrderAuthDetails show={showAuthDetails} close={this.closeAuthDetails} order={entity} pipeline={pipeline} />
        </div>
      </Clearfix>
    );
  }
}
OrderInfos.defaultProps = {
  showProgress: false,
  showActions: true,
  addEditAction: false,
  inModal: false,
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(OrderInfos)));
